'use strict';

exports.__esModule = true;

exports.default = function (name) {
  return typeof Symbol === 'function' ? Symbol(name) : '@@lodable-components/' + name;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/loadable-components/utils/createSymbol.js
// module id = 79
// module chunks = 3